import PanelReviews from "./panelReviews"

const TabNotes = () => <PanelReviews/>

export default TabNotes
